var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "140px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "活动名称", prop: "activityName" } },
        [
          _c("el-input", {
            staticStyle: { width: "400px" },
            attrs: { maxlength: "100", "show-word-limit": "" },
            model: {
              value: _vm.form.activityName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "activityName", $$v)
              },
              expression: "form.activityName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动标题", prop: "activityTitle" } },
        [
          _c("el-input", {
            staticStyle: { width: "400px" },
            attrs: { maxlength: "100", "show-word-limit": "" },
            model: {
              value: _vm.form.activityTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "activityTitle", $$v)
              },
              expression: "form.activityTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "第一屏背景图", prop: "bgImage" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "icon-uploader",
              attrs: {
                "file-list": _vm.fileList,
                size: "mini",
                action: "#",
                "list-type": "picture-card",
                limit: 1,
                "on-remove": _vm.handleUploadRemove,
                "auto-upload": true,
                accept: "image/*",
                "http-request": _vm.handleCustomUpload,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("第一屏展示用背景图"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动时间", prop: "time" } },
        [
          _c("el-date-picker", {
            attrs: {
              type: "datetimerange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "yyyy-MM-dd HH:mm:ss",
            },
            model: {
              value: _vm.time,
              callback: function ($$v) {
                _vm.time = $$v
              },
              expression: "time",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "可领奖次数", prop: "limitCount" } },
        [
          _vm._v("\n        活动期间内可领奖\n        "),
          _c("el-input", {
            staticStyle: { width: "80px", margin: "0 10px" },
            attrs: { size: "mini" },
            model: {
              value: _vm.form.limitCount,
              callback: function ($$v) {
                _vm.$set(_vm.form, "limitCount", _vm._n($$v))
              },
              expression: "form.limitCount",
            },
          }),
          _vm._v("\n        次（默认 1）\n    "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "奖励类型", prop: "rewardType" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.rewardType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "rewardType", $$v)
                },
                expression: "form.rewardType",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("送券")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("送积分")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.rewardType === 1
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: "奖励券",
                prop: "rewardCouponId",
                rules: [
                  {
                    required: true,
                    message: "请选择奖励券",
                    trigger: "change",
                  },
                ],
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: {
                    placeholder: "请选择优惠券,支持模糊查询",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.fetchCoupons,
                    loading: _vm.couponLoading,
                  },
                  model: {
                    value: _vm.form.rewardCouponId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "rewardCouponId", $$v)
                    },
                    expression: "form.rewardCouponId",
                  },
                },
                _vm._l(_vm.couponOptions, function (coupon) {
                  return _c("el-option", {
                    key: coupon.thirdCouponId,
                    attrs: {
                      label: coupon.typeName,
                      value: coupon.thirdCouponId,
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form.rewardType === 2
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: "奖励积分",
                prop: "rewardPoints",
                rules: [
                  {
                    required: true,
                    message: "请填写奖励积分",
                    trigger: "blur",
                  },
                ],
              },
            },
            [
              _c("el-input-number", {
                staticStyle: { width: "200px" },
                attrs: { min: 1, step: 10 },
                model: {
                  value: _vm.form.rewardPoints,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rewardPoints", $$v)
                  },
                  expression: "form.rewardPoints",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "话题名称" } },
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: {
              maxlength: "100",
              "show-word-limit": "",
              placeholder: "调起贴图号时自动带出的话题名称,如 #gaga16周年",
            },
            model: {
              value: _vm.form.topic,
              callback: function ($$v) {
                _vm.$set(_vm.form, "topic", $$v)
              },
              expression: "form.topic",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "贴图卡片跳转页面" } },
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: {
              placeholder:
                "贴图链接卡片跳转的小程序页面路径,如 pages/index/index",
            },
            model: {
              value: _vm.form.recommendPath,
              callback: function ($$v) {
                _vm.$set(_vm.form, "recommendPath", $$v)
              },
              expression: "form.recommendPath",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "贴图卡片标题" } },
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: {
              maxlength: "100",
              "show-word-limit": "",
              placeholder: "贴图链接卡片展示的标题",
            },
            model: {
              value: _vm.form.recommendTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "recommendTitle", $$v)
              },
              expression: "form.recommendTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动规则", prop: "ruleText" } },
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { type: "textarea", rows: 5 },
            model: {
              value: _vm.form.ruleText,
              callback: function ($$v) {
                _vm.$set(_vm.form, "ruleText", $$v)
              },
              expression: "form.ruleText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }